import React, { Component } from "react";
import PropTypes from "prop-types";
import YesNoModal from "./YesNoModal";

class HandicapInfoModal extends Component {
  render() {
    const { isOpen, onAbort, isOkVisible } = this.props;
    return (
      <YesNoModal
        onAbort={onAbort}
        onConfirm={onAbort}
        isOpen={isOpen}
        isYesVisible={isOkVisible}
        isNoVisible={false}
        yesTitle="Ok"
      >
        <h3>Shots Off</h3>
        <p>Shots Off the golfer with the lowest Playing Handicap.</p>
      </YesNoModal>
    );
  }
}

HandicapInfoModal.defaultProps = {
  isOkVisible: false,
};

HandicapInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAbort: PropTypes.func.isRequired,
  isOkVisible: PropTypes.bool,
};

export default HandicapInfoModal;
